import { useState } from 'react'

import useCustomSnackbar from 'Components/UI/Atoms/SnackBar'
import CancelConfirmButtons from 'Components/UI/Molecules/CancelConfirmButtons'
import InputsWithoutValidate from 'Components/UI/Molecules/InputsWithoutValidate'
import DialogComponent from 'Components/UI/Molecules/Modals/DialogComponent'
import { interfaces } from 'service/interfaces'

import { Fields } from './fields'

const SearchProduct = (props) => {
  const {
    data,
    open,
    handleClose,
    render,
    setRender,
    dataInfo,
    rows,
    setRows,
    setData,
    permissions,
  } = props
  const createDismissableSnackbar = useCustomSnackbar()
  const [isLoading, setIsLoading] = useState(false)
  const [info, setInfo] = useState({
    codigo: null,
    descripcion: '',
    nrodev: null,
    oblea: null,
    orden: 1,
    observacion: '',
    empresa: dataInfo.infoMain.origen,
    pedido: dataInfo.infoMain.id,
    cantidad: 1,
    unitario: '',
    total: '',
    subiva: '',
    producto: '',
    alicuota: dataInfo.infoMain.alicuota,
    tipo: '',
    transporte: null,
    medio_pago: null,
    submedio_pago: null,
    porcentaje: null,
    origen: null,
  })

  const handleChange = (name, value) => {
    setInfo((prevInfo) => ({
      ...prevInfo,
      [name]: value,
    }))
  }

  function _renderStepContent() {
    return (
      <>
        <InputsWithoutValidate
          fields={Fields(
            info,
            handleSubmitCode,
            handleChange,
            isLoading,
            data,
            dataInfo,
            permissions
          )}
          spacing={2}
        />
      </>
    )
  }

  async function handleSubmitCode(info) {
    setIsLoading(true)
    try {
      const res = await interfaces.salesOrders.searchProduct(info)
      const clientData = res.data
      const exists = rows.some((row) => row.codigo === clientData.codigo)
      if (exists) {
        createDismissableSnackbar('Este producto ya fue agregado.', {
          variant: 'error',
        })
        setIsLoading(false)
        return
      }
      setInfo({
        ...info,
        codigo: clientData.codigo,
        descripcion: clientData.descripcion,
        nrodev: clientData.nrodev,
        oblea: clientData.oblea,
        unitario: clientData.precio,
        observacion: clientData.observacion,
        id: clientData.id,
        total: clientData.precio,
        producto: clientData.producto,
        origen: clientData.origen,
      })
      setIsLoading(false)
    } catch (error) {
      createDismissableSnackbar(error.response?.data?.data || 'Error al buscar producto.', {
        variant: 'error',
      })
      setIsLoading(false)
    }
  }

  const addProducts = async () => {
    const values = {
      empresa: info.empresa,
      origen: info.origen,
      tipo: info.tipo,
      pedido: info.pedido,
      orden: info.orden,
      descripcion: info.descripcion,
      nrodev: info.nrodev,
      observacion: info.observacion,
      precio: info.unitario,
      codigo: info.codigo,
      cantidad: info.cantidad,
      oblea: info.oblea,
      total: info.unitario,
      producto: info.producto,
      alicuota: Number(info.alicuota),
      transporte: info.transporte,
      medio_pago: info.medio_pago,
      submedio_pago: info.submedio_pago,
      porcentaje: info.porcentaje,
    }

    setIsLoading(true)
    await interfaces.salesOrders
      .addProduct(values)
      .then((res) => {
        setRows((prevRows) => [...prevRows, { ...info }])
        setData((prevData) => ({
          ...prevData,
          productList: [...prevData.productList, { ...info }],
        }))
        handleClose()
        setRender(!render)
        createDismissableSnackbar(res.data, {
          variant: 'success',
        })
      })
      .catch((error) => {
        createDismissableSnackbar(`${error.response.data.data}`, {
          variant: 'error',
        })
      })

    setIsLoading(false)
  }

  const isSubmitDisabled = info.tipo === "BONIFICACION"
    ? Number(info.unitario) > dataInfo.infoMain.saldos.total
    : !info.unitario

  return (
    <DialogComponent
      title="Agregar item"
      open={open}
      handleclose={handleClose}
      handleclosedisabled={isLoading}
      widthLarge="500px"
      disableBackdropClick
      disableEscapeKeyDown
      maxHeight
      children={<div>{_renderStepContent()}</div>}
      actions={
        <CancelConfirmButtons
          disabledSubmit={isLoading || isSubmitDisabled || !info.unitario}
          disabledCancel={isLoading}
          isLoading={isLoading}
          onClickSubmit={addProducts}
          onClickCancel={handleClose}
        />
      }
    />
  )
}
export default SearchProduct
